import { cn } from '@/lib/cn';

/**
 * Upload progress. Accent fill on an inset track, no animation beyond the width transition.
 *
 * `tone="muted"` is for a bar shown *beneath* another one -- the per-file bar under the batch bar.
 * Two identical accent bars stacked read as two equal facts; the second one is a detail of the
 * first, and the fill says so.
 */
export function Progress({
  value,
  tone = 'primary',
  className
}: {
  value: number;
  tone?: 'primary' | 'muted';
  className?: string;
}) {
  const pct = Math.max(0, Math.min(100, Math.round(value * 100)));
  return (
    <div
      role="progressbar"
      aria-valuenow={pct}
      aria-valuemin={0}
      aria-valuemax={100}
      className={cn('h-1 w-full overflow-hidden rounded-full bg-inset', className)}
    >
      <div
        className={cn('h-full transition-[width] duration-200', tone === 'muted' ? 'bg-muted' : 'bg-primary')}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
